import Editor from "../../Components/common/Editor";
import trans from "./../../../Languages/Languages";
import { Form, Input, Select, Card, InputNumber, Button, message } from "antd";
import { useState, useEffect } from "react";
import API from "../../../API";
const FeeStructure = () => {
  const [feeEditorHtml, setFeeEditorHtml] = useState("");
  const handleFeeEditorChange = (html) => {
    setFeeEditorHtml(html);
  };
  const [scholarshipEditorHtml, setScholarshipEditorHtml] = useState("");
  const handleScholarshipEditorChange = (html) => {
    setScholarshipEditorHtml(html);
  };
  const [paymentEditorHtml, setPaymentEditorHtml] = useState("");
  const handlePaymentEditorChange = (html) => {
    setPaymentEditorHtml(html);
  };
  const [textEditorHtml, setTextEditorHtml] = useState("");
  const handleTextEditorChange = (html) => {
    setTextEditorHtml(html);
  };

  const { Option } = Select;
  const [feeStructureData, setFeeStructureData] = useState([]);

  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(true);

  const [kiuFeesLabel, setKiuFeesLabel] = useState(null);
  const [feeStructureSectionLabel, setFeeStructureSectionLabel] = useState(null);
  const [scholarshipEntitlementLabel, setScholarshipEntitlementLabel] = useState(null);
  const [paymentInstructionsLabel, setPaymentInstructionsLabel] = useState(null);
  const [paymentDetailsLabel, setPaymentDetailsLabel] = useState(null);

  const [bankLabel, setBankLabel] = useState(null);
  const [branchLabel, setBranchLabel] = useState(null);
  const [beneficiaryNameLabel, setBeneficiaryNameLabel] = useState(null);
  const [accountNoLabel, setAccountNoLabel] = useState(null);
  const [swiftCodeLabel, setSwiftCodeLabel] = useState(null);

  const [applicationFeesLabel, setApplicationFeesLabel] = useState(null);
  const [fullTimeStudentsLabel, setFullTimeStudentsLabel] = useState(null);
  const [creditHoursLabel, setCreditHoursLabel] = useState(null);
  const [oneCourseModuleLabel, setOneCourseModuleLabel] = useState(null);
  const [runsDuringTermTimeLabel, setRunsDuringTermTimeLabel] = useState(null);


  const [renamingSection, setRenamingSection] = useState(null);
  const [editingSection, setEditingSection] = useState(null);
  const [renameValue, setRenameValue] = useState("");
  const [showContextMenu, setShowContextMenu] = useState(false);
  const [contextMenuPos, setContextMenuPos] = useState({ x: 0, y: 0 });

  ///////////////////////////////////////////////////////////////////////////////////////////////
  ///                             Use Effect
  ////////////////////////////////////////////////////////////////////////////////////////////////
  useEffect(() => {
    setLoading(true);

    const init = async () => {
      await API.get("/admin/fee")
        .then((res) => {
          const data = res.data;

          // Fee data
          setFeeStructureData(data.fee);
          setFeeEditorHtml(data?.fee?.about);
          setTextEditorHtml(data?.fee?.bottom_text);
          setScholarshipEditorHtml(data?.fee?.scholarship_entitlement);
          setPaymentEditorHtml(data?.fee?.payment_instructions);

          // Labels
          setKiuFeesLabel(data.kiuFeesLabel);
          setRenameValue(data.kiuFeesLabel?.title);
          setFeeStructureSectionLabel(data.feeStructureSectionLabel);
          setScholarshipEntitlementLabel(data.scholarshipEntitlementLabel);
          setPaymentInstructionsLabel(data.paymentInstructionsLabel);
          setPaymentDetailsLabel(data.paymentDetailsLabel);

          setBankLabel(data.bankLabel);
          setBranchLabel(data.branchLabel);
          setBeneficiaryNameLabel(data.beneficiaryNameLabel);
          setAccountNoLabel(data.accountNoLabel);
          setSwiftCodeLabel(data.swiftCodeLabel);

          setApplicationFeesLabel(data.applicationFeesLabel);
          setFullTimeStudentsLabel(data.fullTimeStudentsLabel);
          setCreditHoursLabel(data.creditHoursLabel);
          setOneCourseModuleLabel(data.oneCourseModuleLabel);
          setRunsDuringTermTimeLabel(data.runsDuringTermTimeLabel);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    };

    init();
  }, [refresh]);
  ///////////////////////////////////////////////////////////////////////////////////////////////
  ///                             update changes
  ////////////////////////////////////////////////////////////////////////////////////////////////
  const onFinish = async (values) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("account_number", values.accountInfo);
    formData.append("application_fee", values.applicationFee);
    formData.append("bank", values.bank);
    formData.append("beneficiary_name", values.beneficiaryName);
    formData.append("branch", values.branch);
    formData.append("full_time", values.fullTimeStudent);
    formData.append("one_time", values.oneCourseModule);
    formData.append("swift_code", values.swiftCode);
    formData.append("currency", values.currency);
    formData.append("scholarship_entitlement", scholarshipEditorHtml);
    formData.append("payment_instructions", paymentEditorHtml);
    formData.append("bottom_text", textEditorHtml);
    formData.append("about", feeEditorHtml);

    await API.post(`/admin/fee/update`, formData)
      .then((res) => {
        setRefresh(!refresh);
        setLoading(false);
        message.success("Updated Successfully", 3);
      })
      .catch((err) => {
        setLoading(false);
        message.error("something went wrong, please try again", 3);
      });
  };


  useEffect(() => {
    const handleClickOutside = () => setShowContextMenu(false);
    window.addEventListener("click", handleClickOutside);
    return () => window.removeEventListener("click", handleClickOutside);
  }, []);

  const handleRenameSubmit = async () => {
    let page = {
      kiuFeesLabel,
      feeStructureSectionLabel,
      scholarshipEntitlementLabel,
      paymentInstructionsLabel,
      paymentDetailsLabel,
      bankLabel,
      branchLabel,
      beneficiaryNameLabel,
      accountNoLabel,
      swiftCodeLabel,
      applicationFeesLabel,
      fullTimeStudentsLabel,
      creditHoursLabel,
      oneCourseModuleLabel,
      runsDuringTermTimeLabel,
    }[editingSection];

    try {
      await API.put(`/admin/pages/slug/${page.slug}`, { title: renameValue });

      const updater = {
        kiuFeesLabel: setKiuFeesLabel,
        feeStructureSectionLabel: setFeeStructureSectionLabel,
        scholarshipEntitlementLabel: setScholarshipEntitlementLabel,
        paymentInstructionsLabel: setPaymentInstructionsLabel,
        paymentDetailsLabel: setPaymentDetailsLabel,

        bankLabel: setBankLabel,
        branchLabel: setBranchLabel,
        beneficiaryNameLabel: setBeneficiaryNameLabel,
        accountNoLabel: setAccountNoLabel,
        swiftCodeLabel: setSwiftCodeLabel,

        applicationFeesLabel: setApplicationFeesLabel,
        fullTimeStudentsLabel: setFullTimeStudentsLabel,
        creditHoursLabel: setCreditHoursLabel,
        oneCourseModuleLabel: setOneCourseModuleLabel,
        runsDuringTermTimeLabel: setRunsDuringTermTimeLabel,
      };

      updater[editingSection]?.((prev) => ({ ...prev, title: renameValue }));
      setRenamingSection(null);
      setEditingSection(null);
    } catch {
      message.error("Rename failed");
    }
  };

  const handleTitleRightClick = (e, sectionKey, label) => {
    e.preventDefault();
    setContextMenuPos({ x: e.clientX, y: e.clientY });
    setShowContextMenu(true);
    setEditingSection(sectionKey);
    setRenameValue(label?.title);
  };

  const handleTitleDoubleClick = (sectionKey, label) => {
    setRenamingSection(sectionKey);
    setRenameValue(label?.title);
    setEditingSection(sectionKey);
  };

  const renderEditableTitle = (sectionKey, label, fallbackText) => (
    <div
      className="fw-600 fw-15 mb-2"
      onDoubleClick={() => handleTitleDoubleClick(sectionKey, label)}
      onContextMenu={(e) => handleTitleRightClick(e, sectionKey, label)}
    >
      {renamingSection === sectionKey ? (
        <input
          type="text"
          value={renameValue}
          autoFocus
          onChange={(e) => setRenameValue(e.target.value)}
          onBlur={handleRenameSubmit}
          onKeyDown={(e) => e.key === "Enter" && handleRenameSubmit()}
          style={{ padding: "2px 6px", fontSize: "14px" }}
        />
      ) : (
        label?.title || fallbackText
      )}
    </div>
  );

  return (
    <div className='pages-container'>
      <div className='content-wrapper'>
        <Card loading={loading} bordered={false}>
          <div className='bg-content-container fee-structure'>
            {renderEditableTitle("kiuFeesLabel", kiuFeesLabel, trans.KIUFees)}
            <Editor
              key='feeStructures'
              editorHtml={feeEditorHtml}
              setEditorHtml={setFeeEditorHtml}
              handleChange={handleFeeEditorChange}
            />
          </div>
          <Form onFinish={onFinish}>
            {/* Fee structure container */}
            {renderEditableTitle("feeStructureSectionLabel", feeStructureSectionLabel, trans.FeeStructure)}
            <div className='bg-content-container'>
              {/* currency */}
              <div className='mb-14'>
                <div className='fw-400 f-12 mb-2'>{trans.Currency}</div>
                <Form.Item
                  name='currency'
                  initialValue={feeStructureData?.currency}
                >
                  <Select defaultValue='usd' style={{ width: 70 }} className='f-12'>
                    <Option value='USD'>USD</Option>
                    <Option value='SR'>SR</Option>
                    <Option value='RS'>RS</Option>
                    <Option value='EUR'>EUR</Option>
                  </Select>
                </Form.Item>
              </div>

              {/* Application feee */}
              <div className='d-flex justify-content-start mr-102 align-items-center'>
                <div className='fw-600 f-12 mr-102 mb-4' style={{ width: 145 }}>
                  {renderEditableTitle("applicationFeesLabel", applicationFeesLabel, trans.ApplicationFees)}

                </div>
                <div className='accordion-detail '>
                  <span
                    className='fw-400 f-12 mr-102'
                    style={{ width: 145, marginLeft: 85 }}
                  >
                    Amount
                  </span>
                  <Form.Item
                    name='applicationFee'
                    initialValue={feeStructureData?.application_fee}
                  >
                    <InputNumber style={{ width: 136 }} min='0' step='0.01' />
                  </Form.Item>
                </div>
              </div>
              {/* Full tine students */}
              <div className='d-flex justify-content-start mr-102 align-items-center'>
                <div className='fw-600 f-12 mr-102 mb-4' style={{ width: 145 }}>
                  {renderEditableTitle("fullTimeStudentsLabel", fullTimeStudentsLabel, trans.Fulltimestudents)}

                  <div className='fw-400 f-9 gray' style={{ width: 145 }}>
                    {renderEditableTitle("creditHoursLabel", creditHoursLabel, "15-21 credit hours per semester")}
                  </div>
                </div>

                <div className='accordion-detail '>
                  <Form.Item
                    name='fullTimeStudent'
                    initialValue={feeStructureData?.full_time}
                  >
                    <InputNumber
                      style={{ width: 136 }}
                      min='0'
                      step='0.01'
                    // onChange={onChange}
                    />
                  </Form.Item>
                </div>
              </div>
              {/* Full tine students */}
              <div className='d-flex justify-content-start mr-102 align-items-center'>
                <div className='fw-600 f-12 mr-102 mb-4' style={{ width: 145 }}>
                  {renderEditableTitle("oneCourseModuleLabel", oneCourseModuleLabel, trans.Onecoursemodule)}
                  <div className='fw-400 f-9 gray' style={{ width: 145 }}>
                    {renderEditableTitle("runsDuringTermTimeLabel", runsDuringTermTimeLabel, "Runs during term time")}

                  </div>
                </div>
                <div className='accordion-detail'>
                  <Form.Item
                    name='oneCourseModule'
                    initialValue={feeStructureData?.one_time}
                  >
                    <InputNumber
                      style={{ width: 136 }}
                      min='0'
                      step='0.01'
                    // onChange={onChange}
                    />
                  </Form.Item>
                </div>
              </div>
            </div>
            {renderEditableTitle("scholarshipEntitlementLabel", scholarshipEntitlementLabel, trans.ScholarshipEntitlement)}

            <div className='bg-content-container'>
              <div className='fw-400 f-14 mb-2'>{trans.text}</div>
              <Editor
                key='scjhoarlshipsFee'
                editorHtml={scholarshipEditorHtml}
                setEditorHtml={setScholarshipEditorHtml}
                handleChange={handleScholarshipEditorChange}
              />
            </div>
            {renderEditableTitle("paymentInstructionsLabel", paymentInstructionsLabel, trans.Paymentinstructions)}

            <div className='bg-content-container'>
              <div className='fw-400 f-14 mb-2'>{trans.text}</div>
              <Editor
                key='paymentFees'
                editorHtml={paymentEditorHtml}
                setEditorHtml={setPaymentEditorHtml}
                handleChange={handlePaymentEditorChange}
              />
            </div>
            {renderEditableTitle("paymentDetailsLabel", paymentDetailsLabel, trans.PaymentinstrucPaymentdetailstions)}

            {/* payment details */}
            <div className='bg-content-container'>
              {/* bank */}
              <div className='accordion-detail '>
                <div className='f-12 fw-500 input-heading'>{renderEditableTitle("bankLabel", bankLabel, trans.Bank)}
                </div>
                <Form.Item name='bank' initialValue={feeStructureData?.bank}>
                  <Input placeholder={trans.Typehere} className='w-100' />
                </Form.Item>
              </div>
              {/* Branch */}

              <div className='accordion-detail '>
                <div className='f-12 fw-500 input-heading'>{renderEditableTitle("branchLabel", branchLabel, trans.Branch)}
                </div>
                <Form.Item
                  name='branch'
                  initialValue={feeStructureData?.branch}
                >
                  <Input placeholder={trans.Typehere} className='w-100' />
                </Form.Item>
              </div>

              {/* Beneficiary's name */}

              <div className='accordion-detail '>
                <div className='f-12 fw-500 input-heading'>{renderEditableTitle("beneficiaryNameLabel", beneficiaryNameLabel, trans.Beneficiarysname)}
                </div>
                <Form.Item
                  name='beneficiaryName'
                  initialValue={feeStructureData?.beneficiary_name}
                >
                  <Input placeholder={trans.Typehere} className='w-100' />
                </Form.Item>
              </div>

              {/* Account No */}

              <div className='accordion-detail '>
                <div className='f-12 fw-500 input-heading'>{renderEditableTitle("accountNoLabel", accountNoLabel, trans.AccountNo)}
                </div>

                <Form.Item
                  name='accountInfo'
                  initialValue={feeStructureData?.account_number}
                >
                  <Input placeholder={trans.Typehere} className='w-100' />
                </Form.Item>
              </div>

              {/* Swift code */}

              <div className='accordion-detail '>
                <div className='f-12 fw-500 input-heading'>{renderEditableTitle("swiftCodeLabel", swiftCodeLabel, trans.Swiftcode)}
                </div>
                <Form.Item
                  name='swiftCode'
                  initialValue={feeStructureData?.swift_code}
                >
                  <Input placeholder={trans.Typehere} className='w-100' />
                </Form.Item>
              </div>
            </div>
            <div className='bg-content-container'>
              <div className='fw-400 f-14 mb-2'>{trans.text}</div>
              <Editor
                key='bottomTextEditor'
                editorHtml={textEditorHtml}
                setEditorHtml={setTextEditorHtml}
                handleChange={handleTextEditorChange}
              />
            </div>

            {/* save changes */}
            <Button
              className='btn-save-changes'
              type='primary'
              htmlType='submit'
            >
              {trans.Save}
            </Button>
          </Form>
        </Card>
      </div>
      {/* Context Menu */}
      {showContextMenu && (
        <ul
          style={{
            position: "fixed",
            top: contextMenuPos.y,
            left: contextMenuPos.x,
            backgroundColor: "white",
            border: "1px solid #ccc",
            borderRadius: 4,
            listStyle: "none",
            padding: "5px 10px",
            margin: 0,
            zIndex: 1000,
            cursor: "pointer",
            boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
          }}
          onClick={() => {
            setRenamingSection(editingSection);
            setShowContextMenu(false);
          }}
          onMouseLeave={() => setShowContextMenu(false)}
        >
          <li>{trans.Rename}</li>
        </ul>
      )}
    </div>
  );
};

export default FeeStructure;
